// extracted by mini-css-extract-plugin
export default {"bucket":"rEhf9mZ7BSsO3ABKgDsQ","right":"SHNonpZZV_IPq3zkljzc","name":"x8LoCiUb3AbyHCeKXtQ3","description":"Caz9DZmjOkLESXPQ0vYf"};